import React from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { Button } from 'transfix-ui/components/Button'
import { ButtonGroup, IButtonGroupProps } from 'transfix-ui/components/ButtonGroup'

type TBaseControllerProps = ControllerProps<React.ComponentType<any>>
export type IButtonValueProps = {
  value: string
  label: string
}
export interface IControlledButtonGroupProps
  extends Pick<TBaseControllerProps, 'name' | 'control' | 'defaultValue'> {
  ButtonGroupProps?: Partial<Omit<IButtonGroupProps, 'onChange' | 'value'>>
  buttons: IButtonValueProps[]
}

export const ControlledButtonGroup = ({
  control,
  defaultValue,
  name,
  buttons,
  ButtonGroupProps = {},
}: IControlledButtonGroupProps) => {
  return (
    <Controller
      defaultValue={defaultValue}
      control={control}
      name={name}
      render={({ onChange, value }) => {
        return (
          <ButtonGroup value={value} onChange={onChange} {...ButtonGroupProps}>
            {buttons.map(button => {
              return (
                <Button value={button.value} size='small' key={`button-group-${button.value}`}>
                  {button.label}
                </Button>
              )
            })}
          </ButtonGroup>
        )
      }}
    />
  )
}
